import React from 'react';
import './About.css';
import imageTeam from '../assets/image_team.png';

const About: React.FC = () => {
  return (
    <section id="nosotros" className="about">
      <div className="container">
        <div className="about-content">
          <h2 className="section-title">Nosotros</h2>
          <div className="about-grid">
            <div className="about-text">
              <div className="about-image-container">
                <img src={imageTeam} alt="Team" className="about-team-image" />
              </div>
            </div>
            <div className="about-info">
              <h3>Quiénes Somos</h3>
              <p>
                En TERA desarrollamos soluciones para automatizar, optimizar y transformar la gestión empresarial.
                Creemos que el crecimiento de una empresa empieza por hacer las cosas más simples.
              </p>
              <p>
                Queremos que líderes, equipos y empresas tengan más tiempo, más claridad y más control.
                Que puedan enfocarse en lo que realmente importa, mientras la tecnología se encarga del resto.
              </p>
              <div className="about-stats">
                <div className="stat">
                  <div className="stat-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                    </svg>
                  </div>
                  <h4>100+</h4>
                  <p>Procesos Automatizados</p>
                </div>
                <div className="stat">
                  <div className="stat-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 12l2 2 4-4"/>
                      <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c.395 0 .785.025 1.166.072"/>
                      <path d="M22 6l-3 3 3 3"/>
                      <path d="M6 6h.01"/>
                    </svg>
                  </div>
                  <h4>85%</h4>
                  <p>Mejora en Eficiencia</p>
                </div>
                <div className="stat">
                  <div className="stat-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                    </svg>
                  </div>
                  <h4>75%</h4>
                  <p>Reducción de Errores Operativos</p>
                </div>
              </div>
            </div>
          </div>
          <div className="about-values">
            <h3>Nuestros Valores</h3>
            <div className="values-grid">
              <div className="value">
                <div className="value-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                    <path d="M2 17l10 5 10-5"/>
                    <path d="M2 12l10 5 10-5"/>
                  </svg>
                </div>
                <h4>Simplicidad</h4>
                <p>Creemos que la eficiencia no es solo un número, es una forma de trabajar mejor.</p>
              </div>
              <div className="value">
                <div className="value-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                    <line x1="8" y1="21" x2="16" y2="21"/>
                    <line x1="12" y1="17" x2="12" y2="21"/>
                    <polyline points="10,8 14,12 10,16"/>
                  </svg>
                </div>
                <h4>Automatización</h4>
                <p>Automatizar es avanzar. Cuando la tecnología se pone al servicio de las personas, todo avanza.</p>
              </div>
              <div className="value">
                <div className="value-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c.395 0 .785.025 1.166.072"/>
                    <path d="M12 2v4"/>
                    <path d="M12 18v4"/>
                    <path d="M4.93 4.93l2.83 2.83"/>
                    <path d="M16.24 16.24l2.83 2.83"/>
                    <path d="M2 12h4"/>
                    <path d="M18 12h4"/>
                    <path d="M4.93 19.07l2.83-2.83"/>
                    <path d="M16.24 7.76l2.83-2.83"/>
                  </svg>
                </div>
                <h4>Estrategia</h4>
                <p>El verdadero cambio no es complicado: es estratégico. Hacerlo sencillo es nuestra misión.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;